/**
 * Query language detection (EN/ES), used to pick the Algolia index.
 * The site locale (language selector) is the primary signal; detection can only
 * upgrade EN -> ES, so an explicit Spanish choice is never overridden (SKU and
 * brand-name queries look "English" and would otherwise flip ES users back to EN).
 */
function detectQueryLanguage(query) {
  if (!query || typeof query !== 'string') return 'en';
  const q = query.trim().toLowerCase();
  if (q.length < 2) return 'en';
  // Spanish-specific characters are conclusive
  if (/[ñ¿¡áéíóúü]/.test(q)) return 'es';
  // Unambiguous Spanish content/catalog words: one match is enough
  const spanishWords = /\b(producto|productos|buscar|precio|carrito|comprar|tienda|nombre|broca|brocas|taladro|taladros|herramienta|herramientas|martillo|llave|llaves|tornillo|tornillos|piedra|piedras|pulir|pulidor|accesorio|accesorios|muela|muelas|fresa|fresas|mandril|esmeril|amoladora|cepillo|cepillos|lima|limas|punta|puntas|cuchilla|cuchillas|cortar|lijar|perforar|atornillar|colector|colectores|polvo|gracias|hola|bueno|nuevo|nueva|nuevos|nuevas)\b/i;
  if (spanishWords.test(q)) return 'es';
  // Spanish stopwords collide with English words in this catalog ("no", "solo",
  // "kit"), so ambiguous tokens are excluded and two matches are required.
  const stopWords = q.match(/\b(el|la|los|las|de|que|en|un|una|es|por|con|su|para|al|lo|como|pero|sus|le|ya|hay|del|uno|bien)\b/gi);
  if (stopWords && stopWords.length >= 2) return 'es';
  return 'en';
}

document.addEventListener('algolia.hooks.initialize', function() {
  // Fires on every keystroke: pick the EN/ES index per query. Site locale wins;
  // detection only upgrades EN -> ES for Spanish-looking queries on the EN site.
  algoliaShopify.hooks.registerHook('beforeAutocompleteConfigurationOptions', function(config) {
    if (!config || !config.queries || !Array.isArray(config.queries)) return config;
    const locale = ((window.Shopify && window.Shopify.locale) || 'en').split('-')[0];
    const prefix = (algoliaShopify.config && algoliaShopify.config.index_prefix) || '';
    const enProductsIndex = prefix + 'products';
    const esProductsIndex = prefix + 'products_united_states_es';

    config.queries.forEach(function (q) {
      if (!q.indexName || q.indexName.indexOf('products') === -1) return;
      if (q.indexName.indexOf('query_suggestions') !== -1) return;

      const lang = locale === 'es' ? 'es' : detectQueryLanguage(q.query || '');
      if (lang === 'es') {
        q.indexName = esProductsIndex;
      } else if (q.indexName === esProductsIndex || /_es$/i.test(q.indexName)) {
        q.indexName = enProductsIndex;
      }
      // Otherwise keep Algolia's configured index (prod: shopify_gwnproducts, sandbox: shopify_searchtermsproducts).
    });
    return config;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
      // Change the placeholder text of the autocomplete menu
      options.placeholder = (window.algoliaStrings && window.algoliaStrings.searchPlaceholder) || 'Search Our Products';
      return options;
    });

      algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function(_defaultTemplate, templateOptions) {
        const { html, state } = templateOptions;
        return html`
          <div class="aa-footer">
            <a
              class="aa-SeeAllBtn"
              href="${window.Shopify.routes.root}search?q=${state.query}"
            >
              ${(window.algoliaStrings && window.algoliaStrings.seeResults) || 'See results'}
              (${algoliaShopify.helpers.formatNumber(state.context.nbProducts)})
            </a>
          </div>
        `;
      });

    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteProductTemplate",
      function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
        // Modify default options, then return them
        const { html, item, components } = templateOptions;
        let isAdvancedLink = false;
        if (item.meta && item.meta.product && item.meta.product.advanced_plp_link) {
          itemLink = item.meta.product.advanced_plp_link;
          isAdvancedLink = true;
        }
        return html`
      <a
        href="${itemLink}"
        class="aa-ItemLink aa-ProductItem"
        onClick="${() => trackSearchAttribution(item)}"
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemPicture aa-ItemPicture--loaded">
            <img
              src="${algoliaShopify.helpers.renderImage(item, 125).src}"
              srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
              sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
              alt="${item.title}"
            />
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitleWrapper">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: "title" })}
                <span class="algolia-variant">
                  ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                </span>
              </div>
            </div>
            <div class="aa-ItemSku">
              <span class="algolia-sku">
                <strong>SKU:</strong> ${item.sku}
              </span>
            </div>
          </div>
        </div>
      </a>
    `;
      }
    );
});


window.addEventListener('scroll', function() {
  const aaPanel = document.querySelector('.aa-Panel');
  const aaInput = document.querySelector('.aa-Input');

  if (aaPanel) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    aaPanel.style.top = scrollTop + 64 + 'px';

    const aaInputRect = aaInput.getBoundingClientRect();
    const isAaInputVisible = aaInputRect.top >= 0 && aaInputRect.bottom <= window.innerHeight;

    if (isAaInputVisible) {
      aaPanel.style.display = 'block';
    } else {
      aaPanel.style.display = 'none';
    }
  }
});


